import { NavigationDrawerItemProps } from 'components/navigation_drawer/NavigationDrawerItem';
import { SecondaryNavigationItems } from 'components/navigation_drawer/SecondaryNavigationItems';
import { NavigationItemTitle } from 'components/navigation_drawer/styled';
import { StatelessPopup } from 'components/popup/stateless_popup/StatelessPopup';
import * as React from 'react';

export type SecondaryNavigationPopupProps<TTriggerElem extends HTMLElement> = Readonly<{
    parentId: string;
    title: string;
    popupRef: React.RefObject<HTMLDivElement>;
    triggerRef: React.RefObject<TTriggerElem>;
    secondaryNavigationItems: NavigationDrawerItemProps[] | undefined;
    onClose: () => void;
}>;

export function SecondaryNavigationPopup<TTriggerElem extends HTMLElement>({
    parentId,
    title,
    popupRef,
    triggerRef,
    secondaryNavigationItems,
    onClose,
}: SecondaryNavigationPopupProps<TTriggerElem>) {
    const hasSubNavItems =
        secondaryNavigationItems && secondaryNavigationItems.some((item) => item.enabled);

    return (
        <StatelessPopup
            noPadding
            noPopupBackground
            noOverlay
            popupClassName="navigation-popup"
            ref={popupRef}
            anchor={triggerRef.current}
            anchorAlign={{ horizontal: 'right', vertical: 'top' }}
            popupAlign={{ horizontal: 'left', vertical: 'top' }}
            popupSettings={{
                borderRadius: hasSubNavItems
                    ? '0 0.8rem 0.8rem 0.8rem'
                    : '0 0.8rem 0.8rem 0',
                style: {
                    boxShadow: 'var(--nav-popup-shadow)',
                    width: '24rem',
                    backgroundColor: 'var(--nav-popup-background)',
                },
            }}
            onClose={onClose}
        >
            <NavigationItemTitle
                $secondary
                style={{
                    height: 'var(--nav-item-size)',
                    backgroundColor: 'var(--nav-secondary-selected)',
                    color: 'var(--nav-text-selected)',
                    borderRadius: hasSubNavItems ? '0 0.8rem 0 0' : '0 0.8rem 0.8rem 0',
                }}
            >
                {title}
            </NavigationItemTitle>
            {hasSubNavItems && (
                <SecondaryNavigationItems
                    parentId={parentId}
                    show
                    fitToScreenHeight
                    items={secondaryNavigationItems}
                />
            )}
        </StatelessPopup>
    );
}
